/**
 * Week Plan Ending Trigger Component
 *
 * Trigger: "week plan ending soon"
 * No additional fields needed - timing is handled at card level.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const WeekPlanEndingTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.weekPlanEnding')}</span>;
  }

  // Edit mode - no additional fields, timing handled at card level
  return null;
};
